import {useMutation, useQueryClient} from '@tanstack/react-query'
import {httpMarkAllNotificationsAsRead} from '../http/notifications.http'
import {QUERY_KEYS} from '@/queryClient'
import {NotificationCount} from '../types'
import {updateNotificationsInCache} from '../utils/cacheUtils'

export const useMarkAllNotificationsAsRead = () => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: async () => {
            await httpMarkAllNotificationsAsRead()
        },
        onMutate: () => {
            const now = new Date()

            // Get current count data
            const previousCount = queryClient.getQueryData<NotificationCount>([QUERY_KEYS.NOTIFICATION_COUNT])

            // Optimistically update notification count
            queryClient.setQueryData<NotificationCount>([QUERY_KEYS.NOTIFICATION_COUNT], oldData => {
                if (!oldData) return {toRead: 0, total: 0}
                return {
                    ...oldData,
                    toRead: 0 // Set all notifications as read
                }
            })

            // Mark all unread notifications as read
            updateNotificationsInCache(queryClient, notification =>
                notification.readAt ? notification : {...notification, readAt: now}
            )

            return {previousCount}
        },
        onError: (_, __, context) => {
            // Restore previous count on error
            if (context?.previousCount) {
                queryClient.setQueryData([QUERY_KEYS.NOTIFICATION_COUNT], context.previousCount)
            }
        },
        onSettled: () => {
            // Refetch notifications to ensure data consistency
            queryClient.invalidateQueries({queryKey: [QUERY_KEYS.NOTIFICATIONS]})
        }
    })
}
